// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "face_group".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "face_group" table (1:1 with a DB row, on the wire). */
export const faceGroupAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    clientName: z.string().nullable(),
    leadId: z.string().nullable(),
    clientNotes: z.string().nullable(),
    serviceId: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=faceGroup.js.map